(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const currentUrl = new URL(window.location.href);

  if (currentUrl.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const productCard = document.getElementById(
          currentUrl.hash.slice(1)
        );

        if (productCard) {
          productCard.scrollIntoView({
            behavior: 'instant',
            block: 'start'
          });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
